import { BedType } from "@/lib/gql/__generated__/graphql";

export const BEDS_TYPE = [
	{
		key: "シングルベッド",
		value: BedType.Single,
	},
	{
		key: "セミダブルベッド",
		value: BedType.SemiDouble,
	},
	{
		key: "ダブルベッド",
		value: BedType.Double,
	},
	{
		key: "クイーンベッド",
		value: BedType.Queen,
	},
	{
		key: "キングベッド",
		value: BedType.King,
	},
	{
		key: "バンクベッド",
		value: BedType.Bunk,
	},
	{
		key: "布団",
		value: BedType.Futon,
	},
	{
		key: "エクストラベッド",
		value: BedType.ExtraBed,
	},
	{
		key: "ソファベッド",
		value: BedType.SofaBed,
	},
	{
		key: "マットレス",
		value: BedType.Mattress,
	},
];
